import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import { Link } from 'react-router-dom';
import { withTranslation } from "react-i18next";
import Model from '../../../../constants/Model/index';
import * as Func from '../../../../helpers/functions';
import action from '../../../../actions/index';
import * as UserComponent from './component/CommonComponent';
import * as HMS from "../../common/component/Index";
import i18n from "../../../../constants/initLng";
import DEFINE from '../../../../constants/Define';
import * as ANT from 'antd';

let permisionActions = [];

class Users extends Component {

    state = {
        titleTable: Func.getTitleTable(Model.UsersModel.titleTable, ['action'], ['id', 'lastname']),
        modelUser: Model.UsersModel.titleTable,
        viewResetPassword: false,
        componentTable: {
            email: {
                key: 'email',
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <HMS.FilterDropdown
                        setSelectedKeys={setSelectedKeys}
                        selectedKeys={selectedKeys}
                        confirm={confirm}
                        clearFilters={clearFilters}
                    >
                    </HMS.FilterDropdown>
                ),
                filterIcon: filtered => (
                    <ANT.Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                ),
            },
            firstname: {
                title: `${i18n.t('item.user.lastname')} ${i18n.t('item.user.firstname')}`,
                key: 'fullname',
                sorter: (i, k) => i.firstname.length - k.length,
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <HMS.FilterDropdown
                        setSelectedKeys={setSelectedKeys}
                        selectedKeys={selectedKeys}
                        confirm={confirm}
                        clearFilters={clearFilters}
                    >
                    </HMS.FilterDropdown>
                ),
                filterIcon: filtered => (
                    <ANT.Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                ),
                render: (firstname, r) => `${r.lastname} ${firstname}`
            },
            phoneNumber: {
                key: 'phoneNumber',
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <HMS.FilterDropdown
                        setSelectedKeys={setSelectedKeys}
                        selectedKeys={selectedKeys}
                        confirm={confirm}
                        clearFilters={clearFilters}
                    >
                    </HMS.FilterDropdown>
                ),
                filterIcon: filtered => (
                    <ANT.Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                ),
            },
            vgid: {
                key: 'vgid',
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <HMS.FilterDropdown
                        setSelectedKeys={setSelectedKeys}
                        selectedKeys={selectedKeys}
                        confirm={confirm}
                        clearFilters={clearFilters}
                    >
                    </HMS.FilterDropdown>
                ),
                filterIcon: filtered => (
                    <ANT.Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                ),
            },
            deviceId: {
                key: 'deviceId',
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <HMS.FilterDropdown
                        setSelectedKeys={setSelectedKeys}
                        selectedKeys={selectedKeys}
                        confirm={confirm}
                        clearFilters={clearFilters}
                    >
                    </HMS.FilterDropdown>
                ),
                filterIcon: filtered => (
                    <ANT.Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                ),
            },
            deactivated: {
                render: (deactivated) => <HMS.StatusComponent color={!deactivated ? 'green' : 'red'}
                    label={!deactivated ? i18n.t('item.user.active') : i18n.t('item.user.deActive')} />
            },
            mfaEnabled: {
                width: 110,
                render: (mfaEnabled) => <UserComponent.MfaStatus enabled={mfaEnabled} />,
            },
            forceMfa: {
                width: 140,
                render: (forceMfa, record) => (
                    <UserComponent.ForceMfaControl
                        checked={forceMfa}
                        loading={(this.props.users.forceMfaUpdatingIds || []).includes(record.id)}
                        disabled={!permisionActions || !permisionActions.allowUpdate}
                        onChange={(checked) => this.props.onUpdateForceMfa({
                            id: record.id,
                            forceMfa: checked,
                            filters: this.state.filter || {
                                pageSize: this.state.pageSize,
                                pageIndex: this.state.pageIndex,
                            },
                        })}
                    />
                ),
            },
            action: {
                align: 'center',
                render: (text, record) => <UserComponent.EditComponent item={record} permisionActions={permisionActions}
                    onDeleteUser={this.props.onDeleteUser} />,
            }
        },
        users: [],
        pageSize: this.props.users.data.pageSize,
        pageIndex: this.props.users.data.pageIndex,
        totalCount: this.props.users.data.totalCount,
        totalPage: this.props.users.data.totalPage,
        isFetching: false,
        isExport: false,
    };

    componentDidMount() {
        permisionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.USER);
        this.setState({
            pageSize: this.props.users.data.pageSize,
            pageIndex: this.props.users.data.pageIndex,
            totalCount: this.props.users.data.totalCount,
            totalPage: Math.ceil(parseInt(this.props.users.data.totalCount) / parseInt(this.props.users.data.pageSize))
        })
        this.props.onListUsers({ pageSize: this.props.users.data.pageSize, pageIndex: this.props.users.data.pageIndex });
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            isFetching: nextProps.users.isFetching,
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.users.data !== prevProps.users.data) {
            this.setState({
                users: this.props.users.data.result,
                pageSize: this.props.users.data.pageSize,
                pageIndex: this.props.users.data.pageIndex,
                totalCount: this.props.users.data.totalCount,
                totalPage: Math.ceil(parseInt(this.props.users.data.totalCount) / parseInt(this.props.users.data.pageSize))
            })
        }
    }

    onChange = (pagination, filters, sorter) => {
        let newFilters = Func.genaratePaginateFilterSort(pagination, filters, sorter);
        if (newFilters.OrderBy) {
            if (newFilters.OrderBy === "firstname") {
                newFilters.OrderBy = "fullname";
            }
        }
        this.setState({
            filter: newFilters
        });
        this.props.onListUsers(newFilters);
    };

    render() {
        const { t } = this.props;
        const { totalPage, titleTable, users, modelUser, isFetching, totalCount, pageIndex, pageSize, componentTable } = this.state;
        return (
            <Fragment>
                <HMS.PageListComponent>
                    <HMS.HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'users'}
                        titleHeader={t('navigation.users')}
                        // componentRight={
                        //     <Fragment>{
                        //         permisionActions && permisionActions.allowCreate && <Link to={`/users/action`}
                        //             className='btn btn-primary'>+ {t(`action.create`)}</Link>
                        //     }
                        //     </Fragment>
                        // }
                    />
                    <HMS.ListComponent
                        tableKey="user-list"
                        rowKey={record => record.id}
                        loading={{ spinning: isFetching, size: 'large' }}
                        // dataSource={dataSource}
                        dataSource={Func.getDataSource(users, modelUser)}
                        columns={Func.columnsTable({
                            titleTable: titleTable,
                            component: componentTable,
                            itemName: 'user'
                        })}
                        onChange={this.onChange}
                        pagination={{ total: totalCount, totalPage: totalPage, pageSize, current: pageIndex }}
                        componentTableList={{
                            // right: <Fragment>{
                            //     permisionActions && permisionActions.allowCreate && <Link to={`/users/action`}
                            //         className='btn btn-primary'>+ {t(`action.create`)}</Link>
                            // }
                            // </Fragment>
                        }}
                    />
                </HMS.PageListComponent>
            </Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        users: state.userReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        onListUsers: (filters) => {
            dispatch(action.dataUserAction(filters))
        },
        onDeleteUser: (id) => {
            dispatch(action.deleteUserAction(id))
        },
        onUpdateForceMfa: (params) => {
            dispatch(action.updateForceMfaAction(params))
        },
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Users));
